<template>
  <el-dialog
    class="schedule-entrance-test-dialog entrance-need-info-dialog"
    :visible="visible"
    width="480px"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div
      slot="title"
      class="schedule-entrance-test-dialog__header d-flex align-items-center justify-content-between px-4 py-3"
    >
      <h3 class="font-weight-bold mb-0">Thông tin nhu cầu kiểm tra đầu vào</h3>
      <button
        type="button"
        class="schedule-entrance-test-dialog__close btn p-0 d-inline-flex align-items-center justify-content-center"
        @click="handleClose"
      >
        <i class="el-icon-close"></i>
      </button>
    </div>

    <div class="schedule-entrance-test-dialog__body bg-white px-4 pt-4 pb-4">
      <p class="entrance-need-info-dialog__text mb-0">
        <strong>Trạng thái:</strong> Không có nhu cầu kiểm tra đầu vào
      </p>
    </div>

    <div slot="footer" class="schedule-entrance-test-dialog__footer d-flex justify-content-end">
      <el-button class="schedule-entrance-test-dialog__cancel" @click="handleClose">Đóng</el-button>
      <el-button class="schedule-entrance-test-dialog__confirm" type="primary" @click="$emit('register')">
        Đăng ký kiểm tra
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "EntranceNeedInfoDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style src="./entrance/entrance-dialog.css"></style>

<style scoped>
.entrance-need-info-dialog__text {
  color: #3f3b48;
  font-size: 14px;
  line-height: 1.5;
  overflow-wrap: break-word !important;
  word-break: normal !important;
}
</style>
